import styled from 'styled-components';
import { Typography } from 'app/shared/components/Typography/Typography';

export const TitleSt = styled(Typography).attrs({
  variant: 'h6',
})`
  margin: 0;
`;
